<template>
  <div style="margin-top: 20px">Redirecting to the privacy policy...</div>
</template>

<script>
  export default {
    name: 'PrivacyPolicy',
    mounted() {
      window.location.href = 'https://www.oldmutual.co.za/privacy-notice';
    },
  };
</script>
